import FaithEmbed from "../images/FaithEmbed";

const Ep0000ComingSoon = {
    objectName: 'Ep0 - Coming Soon!',
    firstName: 'Ep0ComingSoon',
    lastName: 'Coming Soon!',
    by: '',
    id: 'Ep0000',
    image: FaithEmbed,
    quotes: [
    {
        tabHeading: 'Next Transcript Coming Soon',
        metaDescription: `The next episode is in production and coming soon.`,
        keywords: ["TrueLibertyNorth", "TrueLibertyNorth Podcast Transcripts", "True Liberty North Podcast Transcripts"],
        title: '(Currently In Production)',
        id: 'Ep0000CS',
        date: 'Coming Soon!',
        headTitle: `Episode 0 - Coming Soon!`,
        headDescription: `Abandon my principles in order to save my principles has become a dominant theme, but just exactly how does that work?!`,
        content: [
              {normal: `Coming real soon!!!`},
              {normal: `Keep checking back`}
        ],
        considerations: [
            {
                name: '',
                title: 'CS Lewis - Mere Christianity Book 4 Ch 6',
                date: '',
                content: [`I feel a strong desire to tell you-and I expect you feel a strong desire to tell me-which of these two errors is the worse. That is the devil 
              getting at us. He always sends errors into the world in pairs-pairs of opposites. And he always encourages us to spend a lot of time thinking which is the 
              worse. You see why, of course? He relies on your extra dislike of the one error to draw you gradually into the opposite one. But do not let us be fooled. We 
              have to keep our eyes on the goal and go straight through between both errors. We have no other concern than that with either of them.`]
            },
            {
                name: '',
                title: 'John Quincy Adams',
                date: '',
                content: [`Always vote for principle, though you may vote alone, and you may cherish the sweetest reflection that your vote is never lost.`]
            },
            {
              name: '',
              title: 'Aesop',
              date: '',
              content: [`We hang the petty thieves and appoint the great ones to public office.`]
            },
            {
              name: '',
              title: 'Thomas Sowell',
              date: '',
              content: [`It is usually futile to try to talk facts and analysis to people who are enjoying a sense of moral superiority in their ignorance.`]
            }
          ]
    }    
]};

export default Ep0000ComingSoon;